import { __awaiter, __generator } from "tslib";
/**
 * Memory adapter
 */
var Memory = /** @class */ (function () {
    function Memory() {
        this.records = [];
    }
    Memory.prototype.record = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var adapter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getName()];
                    case 1:
                        adapter = _a.sent();
                        this.records.push(request);
                        response = {
                            adapter: adapter,
                            finalRequest: request,
                            isResponseConfirmed: false,
                            isSuccess: true,
                        };
                        return [2 /*return*/, Promise.resolve(response)];
                }
            });
        });
    };
    Memory.prototype.getName = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, "Memory"];
            });
        });
    };
    Memory.prototype.getRecords = function () {
        return this.records;
    };
    return Memory;
}());
export default Memory;
//# sourceMappingURL=Memory.js.map